import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'eddydata-lib';
import { TransferenciaPendenteRptComponent } from './transferencia-pendente-rpt.component';

const routes: Routes = [
  { path: '', component: TransferenciaPendenteRptComponent, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TransferenciaPendenteRptRoutingModule { }
